"use client"

import Link from "next/link"

import { useAnalyticsContext } from "@/components/analytics-provider"
import { Chevron } from "@/components/svg"
import { Img } from "@/components/ui/image"
import { Translate } from "@/components/ui/translate"
import { H3 } from "@/components/ui/typography"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type PdvBannerProps = {
  searchParams: { [key: string]: string }
}
/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/
const PdvBanner = ({ searchParams }: PdvBannerProps) => {
  const { sendData } = useAnalyticsContext()

  const handleClick = () => {
    sendData({
      event: "link_click",
      event_name: "reg_event",
      position: "pdv",
      cta_label: "registrazione punto vendita",
      click_detail: "registrati_punto_vendita",
    })
  }
  const APP_VENDOR =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR

  return (
    <Link
      className="rounded-card border-pdv-banner-border bg-paper flex cursor-pointer justify-between gap-2 border p-4"
      href={{
        pathname: "/registrazione-pdv",
        query: searchParams,
      }}
      onClick={handleClick}
    >
      <div className="flex items-center gap-2">
        <Img
          src={
            APP_VENDOR === "snai"
              ? "/home-page/snai/pdv-banner.svg"
              : "/home-page/pdv-banner.svg"
          }
          alt="pdv banner"
          width={42}
          height={42}
        />
        <div className="flex flex-col gap-2">
          <H3
            className="font-primary text-paragraph-m text-header-text font-bold"
            i18nKey={"InitialPage.pdvBannerTitle"}
          />
          <p className="text-paragraph-s text-header-text">
            <strong>
              <Translate i18nKey="InitialPage.pdvBannerText1" />
            </strong>{" "}
            <Translate i18nKey="InitialPage.pdvBannerText2" />
          </p>
        </div>
        <div className="min-w-6">
          <Chevron />
        </div>
      </div>
    </Link>
  )
}

export { PdvBanner }
